import { apiBusSchedBaseURL } from '../../authentication/Global';
import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class LayoutAPI {
    constructor(appName) {
        switch(appName) {
            case "bussched":
                this.baseUrl = new URL("bussched/layouts/", apiBusSchedBaseURL);
                break;
            case "schematicmap":
                this.baseUrl = new URL("schematicmap/layouts/", apiSchematicMapBaseURL);
                break;
            default:
                this.baseUrl = new URL("");
                break;
        }
    }

    create(layout) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(layout)
        });
    }

    update(layoutId, layout) {
        return API.authenticatedRequest({
            url: new URL(layoutId, this.baseUrl),
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(layout)
        });
    }

    copy(layout) {
        return API.authenticatedRequest({
            url: new URL("copy", this.baseUrl),
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(layout)
        });
    }

    delete(layoutId) {
        return API.authenticatedRequest({
            url: new URL(layoutId, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    list(folderId) {
        const url = new URL(this.baseUrl);
        if (folderId === null) {
            url.searchParams.set("unassigned", "true");
        } else if (folderId !== undefined) {
            url.searchParams.set("folderId", folderId);
        }

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    assignFolder(layoutId, folderId) {
        return API.authenticatedRequest({
            url: new URL(`${layoutId}/folder`, this.baseUrl),
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify({ folderId: folderId !== undefined ? folderId : null })
        });
    }
}